import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { NoteDetailModel } from '../../Models/Models/Customer/NoteDetailModel';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class NoteDetailClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<NoteDetailModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/NoteDetail/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<NoteDetailModel>, any>(url, data);
  }
  public post(customerId: number, noteDetailModel: NoteDetailModel): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/NoteDetail/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, noteDetailModel: noteDetailModel }

    return AjaxWrapper.post<ValidationStatus, any>(url, data);
  }
  public put(customerId: number, noteDetailModel: NoteDetailModel): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/NoteDetail/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, noteDetailModel: noteDetailModel }

    return AjaxWrapper.put<ValidationStatus, any>(url, data);
  }
  public delete(customerId: number, noteDetailModel: NoteDetailModel): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/NoteDetail/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, noteDetailModel: noteDetailModel }

    return AjaxWrapper.delete<ValidationStatus, any>(url, data);
  }
}

